<template>
    <div class="tickets-filter__breadcrumbs" ref="sortingMenuElement">
        <template v-for="sortingOption in TicketsSortingOption" :key="sortingOption">
            <input type="radio" :id="sortingOption" :value="sortingOption" v-model="selectedSorting" />
            <label
                :for="sortingOption"
                :class="[
                    { 'tickets-filter__breadcrumb--active': selectedSorting === sortingOption },
                    'tickets-filter__breadcrumb',
                ]"
                >{{ getSortingButtonText(sortingOption) }}</label
            >
        </template>
    </div>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted, ref } from "vue";
import { isClickInsideElement } from "@sazka/utils/click-inside-element";
import { TicketsSortingOption } from "@/tickets/utils/tickets-sorting-option-enum";

const selectedSorting = defineModel<TicketsSortingOption>();

const emit = defineEmits(["closeMenu"]);

const sortingMenuElement = ref<HTMLDivElement>();

function getSortingButtonText(clickedSort: TicketsSortingOption) {
    switch (clickedSort) {
        case TicketsSortingOption.Default:
            return "Doporučené";
        case TicketsSortingOption.PriceAscending:
            return "Od nejlevnějšího losu";
        case TicketsSortingOption.PriceDescending:
            return "Od nejdražšího losu";
        case TicketsSortingOption.WinAscending:
            return "Od nejmenší výhry";
        case TicketsSortingOption.WinDescending:
            return "Od největší výhry";
    }
}

function handleEscPress(event: KeyboardEvent) {
    if (event.key === "Escape") {
        emit("closeMenu");
    }
}

function handleClickOutside({ clientX, clientY }) {
    if (!isClickInsideElement(sortingMenuElement.value, { x: clientX, y: clientY })) {
        emit("closeMenu");
    }
}

onMounted(() => {
    window.addEventListener("keydown", handleEscPress);

    // This timeout is necessary so that the event listener is added only after the component is fully loaded
    setTimeout(() => {
        window.addEventListener("click", handleClickOutside);
    }, 0);
});

onUnmounted(() => {
    window.removeEventListener("keydown", handleEscPress);
    window.removeEventListener("click", handleClickOutside);
});
</script>
